import { render, staticRenderFns } from "./FiltrosDash.vue?vue&type=template&id=4243819c&"
import script from "./FiltrosDash.vue?vue&type=script&lang=js&"
export * from "./FiltrosDash.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosDash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/FiltrosDash.vue
// module id = 443
// module chunks = 28